import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-table-actions',
  templateUrl: './table-actions.component.html',
})
export class TableActionsComponent implements OnInit {
  @Output() deleteClicked = new EventEmitter();
  @Output() editClicked = new EventEmitter();
  @Output() viewClicked = new EventEmitter();
  @Output() hideClicked = new EventEmitter();
  @Output() unhideClicked = new EventEmitter();
  @Output() duplicateClicked = new EventEmitter();
  @Output() setGiftsClicked = new EventEmitter();
  @Input() showDeleteButton = true;
  @Input() showEditButton = true;
  @Input() showSetGiftsButton = false;
  @Input() showViewButton = false;
  @Input() showHideButton = false;
  @Input() showUnhideButton = false;
  @Input() showDuplicateButton = false;

  constructor() {}

  ngOnInit(): void {}

  onEditClicked() {
    this.editClicked.emit();
  }

  onViewClicked() {
    this.viewClicked.emit();
  }

  onDeleteClicked() {
    this.deleteClicked.emit();
  }
  onHideClicked() {
    this.hideClicked.emit();
  }
  onUnhideClicked() {
    this.unhideClicked.emit();
  }
  onDuplicateClicked() {
    this.duplicateClicked.emit();
  }

  onSetGiftsClicked() {
    this.setGiftsClicked.emit();
  }
}
